import * as types from './threadActionTypes';

export const getThreadRequestAction = (payload) => ({
  type: types.GET_THREAD_REQUEST,
  payload,
});

export const getThreadDataAction = (payload) => ({
  type: types.GET_THREAD_DATA,
  payload,
});

export const getThreadErrorAction = (payload) => ({
  type: types.GET_THREAD_ERROR,
  payload,
});

export const createThreadRequestAction = (payload) => ({
  type: types.CREATE_THREAD_REQUEST,
  payload,
});

export const createThreadDataAction = (payload) => ({
  type: types.CREATE_THREAD_DATA,
  payload,
});

export const createThreadErrorAction = (payload) => ({
  type: types.CREATE_THREAD_ERROR,
  payload,
});

export const updateThreadRequestAction = (payload) => ({
  type: types.UPDATE_THREAD_REQUEST,
  payload,
});

export const updateThreadDataAction = (payload) => ({
  type: types.UPDATE_THREAD_DATA,
  payload,
});

export const updateThreadErrorAction = (payload) => ({
  type: types.UPDATE_THREAD_ERROR,
  payload,
});

export const deleteThreadRequestAction = (payload) => ({
  type: types.DELETE_THREAD_REQUEST,
  payload,
});

export const deleteThreadDataAction = (payload) => ({
  type: types.DELETE_THREAD_DATA,
  payload,
});

export const deleteThreadErrorAction = (payload) => ({
  type: types.DELETE_THREAD_ERROR,
  payload,
});
